import { render, staticRenderFns } from "./SingleLineDataTableNeo.vue?vue&type=template&id=48b244c8&scoped=true&"
import script from "./SingleLineDataTableNeo.vue?vue&type=script&lang=js&"
export * from "./SingleLineDataTableNeo.vue?vue&type=script&lang=js&"
import style0 from "./SingleLineDataTableNeo.vue?vue&type=style&index=0&id=48b244c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b244c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VIcon,VTooltip})
